/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select'
import DynamicEditor from "./DynamicEditor";
import { CHATGPT } from "../common/constants";
import { fetchGlobalSetting, saveGlobalSetting } from "../action/common";
import AiSystemPromptPreviewModal from "../../pages/Settings/Modal/AiSystemPromptPreviewModal";

function AiAssistant({ activeTab, setActiveTab }) {
    const { theme, colorPicker, colorPickerDark } = useSelector(state => state.theme);
    const [settings, setSettings] = useState({});
    const [saving, setSaving] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const { MODELS } = CHATGPT;

    const getSettings = async () => {
        try{
            const response = await fetchGlobalSetting();
            let settings = {}
            if(response?.data?.responseData) {
                response?.data?.responseData.map((item) => {
                    settings = { ...settings, [item?.settingName]: item?.settingValue };
                });

                setSettings(settings);
            }
        } catch(e) {}
    }

    const saveSettings = async (e) => {
        e.preventDefault();
        setSaving(true)
        try{
            const response = await saveGlobalSetting({settings});
            if(response?.data?.responseData) {
                setSaving(null)
            }
        } catch(e) {
            console.log(e)
            setSaving(false)
        }
    }

    const handleChange = (value, name) => {
        setSettings((prev) => ({ ...prev, [name]: value }));
        setSaving(false)
    }

    const previewPrompt = (e) => {
        e.preventDefault();
        setShowPreviewModal(true);
    }

    useEffect(() => {
        getSettings();
    }, []);

    return (
        <>
            <li
            css={{
                '&:hover .accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
                },
                '.accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "aiassistant")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "aiassistant")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "aiassistant")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "aiassistant")) ? "black !important" : "white !important") : "white"
                }
            }}
            className={`li-setting-tab ${activeTab == "aiassistant" ? 'active' : ''}`}>
                <div className="settings-accordion-tab"
                    onClick={() => { setActiveTab(activeTab => activeTab == 'aiassistant' ? null : 'aiassistant'); }}
                    css={{
                    background: activeTab == 'aiassistant' ? `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important` :
                        '',
                    '&:hover': {
                        background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important`,
                    }
                    }}>
                    <div className="settings-accordion-heading">
                    <figure className="settings-icon">
                        <img src="/images/general.svg" className="img-default dark:invert-color" />
                    </figure>
                    <h3 className="accordion-title uppercase dark:text-white">AI Assistant</h3>
                    </div>
                    <div className="settings-accordion-arrow">
                        <img src="/images/arrow-down.svg" className="dark:invert-color" />
                    </div>
                </div>
                {
                    activeTab == 'aiassistant' 
                    && 
                    <div className="settings-accordion-content">
                        <div className="inner-form">
                            <label className="field-label font text-black mb-0">AI Assistant System prompt</label>
                            <div className="block-field-info font text-secondary text-base">The prompt used by all users for each session</div>
                            <div className="block-field-info font text-secondary text-base">Variables:</div>
                            <div>
                                <DynamicEditor onInput={(content) => handleChange(content, 'aiAssistantSystemPrompt')} value={settings?.aiAssistantSystemPrompt ?? ''} />
                                <button className="changeName mt-5"
                                css={{
                                    background: theme == "dark" ? `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000 !important` : `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), #ffffff !important`,
                                    color: `var(--accent-color) !important`
                                }}
                                onClick={previewPrompt}>Preview</button>
                            </div>

                            <div className="mt-10">
                                <label className="field-label font text-black mb-0">API Keys</label>
                                <div className="block-field-info font text-secondary text-base">API key used for all LifeTab users.</div>

                                <div className="field-block mt-[30px]">
                                    <label className="field-label dark:text-white dark:opacity-70">OpenAI</label>    
                                    <div className="field-data">
                                        <input value={settings?.openAiApiKey ?? ''} type="text" className="input-field" placeholder="Enter your OpenAI API key" onInput={(e) => handleChange(e.target.value, "openAiApiKey")} />
                                    </div>
                                </div>
                                <div className="field-block mt-[30px]">
                                    <label className="field-label dark:text-white dark:opacity-70">Anthropic</label>
                                    <div className="field-data">
                                        <input value={settings?.anthropicApiKey ?? ''} type="text" className="input-field" placeholder="Enter your Anthropic API key" onInput={(e) => handleChange(e.target.value, "anthropicApiKey")} />
                                    </div>
                                </div>
                                <div className="field-block mt-[30px]">
                                    <label className="field-label dark:text-white dark:opacity-70">Default Model</label>
                                    <div className="field-data">
                                        <div className="filed-data-block" css={{
                                            '.general-setting__option--is-selected': {
                                            background: `linear-gradient(0deg, var(--accent-color), var(--accent-color)), var(--theme-mode-color-white) !important;`
                                            }
                                            }}  >
                                            <Select
                                                placeholder="Select AI Model"
                                                onChange={(value) => handleChange(value.value, 'aiAssistantModel')}
                                                options={MODELS}
                                                value={MODELS.filter(option => option.value === settings?.aiAssistantModel)?.[0] ?? null}
                                                className="react-select"
                                                classNamePrefix={"general-setting"}
                                                classNames={{control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="field-block mt-[60px]">
                                    <button className="changeName mt-5"
                                    css={{
                                        background: theme == "dark" ? `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #000000 !important` : `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), #ffffff !important`,
                                        color: `var(--accent-color) !important`
                                                
                                    }}
                                    onClick={saveSettings}>{saving === true ? 'Saving...' : (saving === false ? 'Save Settings' : 'Saved')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </li>
            {showPreviewModal && <AiSystemPromptPreviewModal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} theme={theme} dateFormat={settings?.dateFormat} content={settings?.aiAssistantSystemPrompt ?? ''} />}
        </>
    );
}

export default AiAssistant;